// This file is generated by a script and should not be modified directly.
const markdown: string = "Une opportunité d’emploi possède un cycle de vie : une date de création et une date d'expiration.\n"
export default markdown
